export default {"src":"/_next/static/media/mainnet-explorer.2ab6daef.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};